@if (validated && !valid) {
  <div class="ct-alert" @collapse>
    <fa-icon class="text-red" [icon]="icons.exclamationCircle" size="lg"></fa-icon>
    <span>{{ 'jobboard.platform.settings.tfa.wrong-code' | transloco }}</span>
  </div>
}

<div class="ct-tfa-otp" (click)="focus()">
  <p-inputOtp
    [length]="6"
    [integerOnly]="true"
    [mask]="false"
    [autofocus]="false"
    [styleClass]="validated && !valid ? 'ct-totp-input ct-totp-invalid' : 'ct-totp-input'"
    [(ngModel)]="tfaValue"
    [ngModelOptions]="{ standalone: true }"
    (onChange)="onOtpChange($event)"
  ></p-inputOtp>
</div>
